module.exports = "<p-growl [value]=\"rootService.toast.msgs\"></p-growl>\r\n<p-confirmDialog #cd closeOnEscape=\"true\" responsive=\"true\">\r\n  <p-footer>\r\n    <button type=\"button\" pButton icon=\"fa-close\" label=\"{{'form.common.no' | translate}}\" (click)=\"cd.reject()\"></button>\r\n    <button type=\"button\" pButton icon=\"fa-check\" label=\"{{'form.common.yes' | translate}}\" (click)=\"cd.accept()\"></button>\r\n  </p-footer>\r\n</p-confirmDialog>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 563
// module chunks = 0